import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';
import { PdfTemplateEntity } from './pdf-template.entity';

/**
 * PD-14688 — assigns a PDF template to a company, so multi-company tenants
 * can print different layouts (remit-to addresses, license bars, branding)
 * per issuing company. A company can hold at most one assignment per
 * document type — enforced in the service, since the document type lives on
 * the template row, not here.
 */
@Index(
	'fk_pdf_template__id_fk_company__id',
	['fkPdfTemplateId', 'fkCompanyId'],
	{
		unique: true,
	},
)
@Index('fk_company__id', ['fkCompanyId'], {})
@Entity('pdf_template_company', {}, { label: 'PDF Template Company' })
export class PdfTemplateCompanyEntity extends BaseEntity {
	@Column('int', { name: 'fk_pdf_template__id', unsigned: true })
	public fkPdfTemplateId!: number;

	@Column('int', { name: 'fk_company__id', unsigned: true })
	public fkCompanyId!: number;

	@ManyToOne(
		() => PdfTemplateEntity,
		(template) => template.companyAssignments,
		{
			onDelete: 'NO ACTION',
			onUpdate: 'NO ACTION',
		},
	)
	@JoinColumn([{ name: 'fk_pdf_template__id', referencedColumnName: 'id' }])
	public fkPdfTemplate!: PdfTemplateEntity;

	@ManyToOne(() => CompanyEntity, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public fkCompany!: CompanyEntity;
}
